<template>
  <div>
    <section>
      <div class="container">
        <div class="row justify-content-center">

          <div class="col-lg-7 text-center mb-5">
            <h2>LIFESTYLE ARTICLES</h2>
            <p>Immerse yourself in the art of indulgence, where luxury living takes centre stage.<br> Discover secluded
              holiday destinations, exquisite wines, the finest restaurants, private events, flawless interior decorating,
              inspiring landscaping designs and more. Embrace the extraordinary and delve into a lavish lifestyle.</p>
          </div>

          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/digital-wealth" style="text-decoration: none;" class="d-block">
                    <img src="/images/lifestyle/digital-wealth.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog" /></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/digital-wealth" style="text-decoration: none;" class="d-block">
                  <h2 class="text-start text-uppercase"><strong>Moving between digital wealth and luxury property </strong></h2>
                        </a>

                        <p class="blog-text">
                        Luxury property has always been one of the preferred ways for affluent individuals to preserve and grow wealth. Today, however, a growing number of high net-worth investors are also holding substantial portions of their wealth in digital assets such as Bitcoin, Ethereum, Solana and stablecoins.
                        </p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/digital-wealth"
              id="lifestyle-cta">READ MORE</a>
          </div>
          
          

             <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/wintering-well" class="d-block"><img src="/images/lifestyle/wintering-well.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog"/></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/wintering-well" style="text-decoration: none;" class="d-block">
                   <h2 class="text-start text-uppercase"><strong>Sanctuary season: The art of wintering well</strong></h2>
                        </a>
                        <p class="blog-text">
                        With South Africa now firmly in the grip of winter, luxury homeowners are embracing a more intentional way of living that prioritises restoration, comfort and holistic wellbeing. 
                        </p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/wintering-well"
              id="lifestyle-cta">READ MORE</a>
          </div>


          <div class="col-12 pb-5">
            <div class="p-3 bg-light rounded">
              <div class="row">
                <div class="col-lg-5 col-md-6 p-3">
                  <div class="h-100">
                    <a href="/article/going-global" style="text-decoration: none;" class="d-block"><img src="/images/lifestyle/going-global.jpg" style="border-bottom-right-radius: 30px;"
                      class="mw-100" alt="Featured Blog"/></a>
                  </div>
                </div>
                <div class="col-lg-7 col-md-6 pe-lg-5 pt-4">
                  <a href="/article/going-global" style="text-decoration: none;" class="d-block">
                  <h2 class="text-start text-uppercase"><strong>Luxury without borders: Why affluent buyers are going global</strong></h2></a>
                  <p>From Florence to Cape Town and Dubai, JamesEdition Data Insights spotlight the cities redefining luxury living for the world’s wealthiest buyers.</p>
                </div>
              </div>
            </div>
            <a class="social-links switch-bg-dblue mb-0 cta-link" href="/article/going-global"
              id="lifestyle-cta">READ MORE</a>
          </div>

          

        </div>
      </div>
    </section>
  </div>
</template>

<script>

export default {
  data() {
    return {
      property: {

      }
    };
  },
};
</script>